import LayoutPrimary from '../../layouts/Primary';
import PopulationCreate from '../../views/Admin/Config/Population/PopulationCreate';
import PopulationEdit from '../../views/Admin/Config/Population/PopulationEdit';

export default [
    {
        path: '/population/create/:fieldToPopulate?',
        name: 'PopulationCreate',
        component: PopulationCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/population/edit/:routerParamPopulationId',
        name: 'PopulationEdit',
        component: PopulationEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
];
